module.exports = __webpack_public_path__ + "media/banners/finansowanie-banner-e777d616.png";